module.exports = {
	"articleTitle1": "Decoding the Martha myth",
	"catImage": "redstar.png",
	"totalCats": 1,
	"name": "Martha Cook",
	"articleLink1": "https://www.michigandaily.com/content/decoding-martha-myth",
	"articleLink2": "https://www.michigandaily.com/section/news/martha-cook-100th-year",
	"articleSnippet1": "Apr 11, 2001 ... Now, traversing the main corridor, its chandeliers hanging from the vaulted \nceiling, I\"m more likely to wonder how Martha Cook ever felt like ...",
	"articleSnippet2": "Oct 25, 2015 ... LSA senior Amy Pestenariu, Martha Cook board president, loads items for the \n2015 time capsule into a safe on Sunday. Current and former ...",
	"totalMisc": 0,
	"articleTitle2": "Residents, alumni mark Martha Cook's 100th year ",
	"address": "906 S University Ave, Ann Arbor, MI 48109",
	"images": [],
	"position": {
		"lat": 42.274852,
		"lng": -83.737822
	},
	"tips": [],
	"bathroomrating": [],
	"categories": {
		"dorm": 1,
		"misc": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/marthacook.json
// module id = 914
// module chunks = 0